import React, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Popover, Typography, Box, Avatar } from '@mui/material';
import Button from '../custom/Button';
import { useNavigate } from 'react-router-dom';
import AccountSidebar from '../AccountSidebar/AccountSidebar';
import { useAuth } from '../../utils/context/useAuthContext';

interface FormValues {
  startYear: string;
  startMonth: string;
  endYear: string;
  endMonth: string;
}

const AccountPopover: React.FC = () => {
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);

  const toggleSidebar = () => {
    setOpen(!open);
  };

  const { user } = useAuth();
  const userId = user?.userId;
  const role = user?.role;

  return (
    <>
      <Box sx={{ cursor: 'pointer' }} onClick={toggleSidebar}>
        <Avatar
          sx={{
            borderRadius: '15px',
            width: '45px',
            height: '45px',
            bgcolor: '#DBE4EC',
            color: '#343434',
            fontWeight: '900',
            fontSize: '12px',
            fontFamily: 'Montserrat',
          }}
        >
          P
        </Avatar>
      </Box>
      {userId && role && (
        <AccountSidebar
          open={open}
          userId={userId}
          userRole={role}
          toggleSidebar={toggleSidebar}
        />
      )}
    </>
  );
};

export default AccountPopover;
